module.exports = __webpack_public_path__ + "static/media/IMG_7836.a061284c.JPG";